import { Observable } from 'rxjs';

export interface DataCountCardRequest<TFilters = unknown> {
  staffId: number;
  typeId: number;
  filters?: TFilters;
  filterString?: string | null;
}

export interface DataCountCardResponse {
  count: number;
  reportLink?: string | null;
  dynamicDate?: boolean;
  days?: number;
}

export interface DataCountCardDataSource<TFilters = unknown> {
  load(context: DataCountCardRequest<TFilters>): Observable<DataCountCardResponse>;
  export(context: DataCountCardRequest<TFilters>): Observable<unknown>;
}

export const DEFAULT_DATA_COUNT_THRESHOLD = 100000;
